export const generateExampleTrustPolicyStatement = (
  accountName: string,
  awsAccountId: string,
  tagAssumeRole: boolean
) => ({
  Version: "2012-10-17",
  Statement: [
    ...(tagAssumeRole
      ? [
          {
            Action: "sts:TagSession",
            Effect: "Allow",
            Principal: {
              AWS: awsAccountId,
            },
          },
        ]
      : []),
    {
      Action: "sts:AssumeRole",
      Condition: {
        StringLike: {
          "sts:ExternalId": `${accountName}@*`,
        },
      },
      Effect: "Allow",
      Principal: {
        AWS: awsAccountId,
      },
    },
  ],
});
